import {
    OnlyWhenUrgencySignalsEnabled,
    UrgencyCategories,
    UrgencyMessages,
} from '@eventbrite/urgency-signals';
import React from 'react';

export const UrgencySignalsWrapper: React.FC<{
    eventHasDiscount: boolean;
}> = ({ eventHasDiscount }) => {
    return (
        <OnlyWhenUrgencySignalsEnabled>
            <div>
                <div className="urgency-signals">
                    {!eventHasDiscount && (
                        <div className="eds-show-down-mn">
                            <UrgencyMessages />
                        </div>
                    )}
                    <div className="urgencySignal-category_section">
                        <UrgencyCategories />
                    </div>
                </div>
            </div>
        </OnlyWhenUrgencySignalsEnabled>
    );
};
